import {
  completeReceiptParse,
  imagePrompt,
  ParsedReceiptResponse,
} from "./parseReceiptText";

export default async function parseReceiptImage(
  image: File,
): Promise<ParsedReceiptResponse> {
  const dataUrl: string = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(image);
  });

  return await completeReceiptParse([
    { type: "text", text: imagePrompt },
    { type: "image_url", image_url: { url: dataUrl, detail: "high" } },
  ]);
}
